"use client";

import { c as _c } from "react/compiler-runtime";
import { Table } from "@opensea/ui-kit";
import { range } from "es-toolkit";
import { useItemView } from "../../ItemViewProvider";
import { ProfileItemsTableHeader } from "./ProfileItemsTableHeader";
import { ProfileItemsTableSkeletonRow } from "./ProfileItemsTableSkeletonRow";
const ITEMS = range(50).map(() => undefined);
export function ProfileItemsTableSkeleton(t0) {
  const $ = _c(8);
  const {
    overrides
  } = t0;
  const {
    size
  } = useItemView();
  const t1 = overrides?.Header?.className;
  let t2;
  if ($[0] !== t1) {
    t2 = <ProfileItemsTableHeader className={t1} />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== overrides) {
    t3 = t4 => {
      const {
        index: index_0
      } = t4;
      return <ProfileItemsTableSkeletonRow key={index_0} overrides={overrides} />;
    };
    $[2] = overrides;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== size || $[5] !== t2 || $[6] !== t3) {
    t4 = <Table className="pb-4" header={t2} itemKey={_temp} items={ITEMS} renderRow={t3} size={size} />;
    $[4] = size;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}
function _temp(_, index) {
  return String(index);
}